module.exports = {
  apiKey: 'AIzaSyCN4K1wOLLSIww4tBXvTpFCTEON1gBHEDM',
  authDomain: 'clickpost-tracking.firebaseapp.com',
  databaseURL: 'https://clickpost-tracking.firebaseio.com',
  projectId: 'clickpost-tracking',
  storageBucket: 'clickpost-tracking.appspot.com',
  messagingSenderId: '915444012014',
  appId: '1:915444012014:web:c0244ee83d235780fab4ff',
  measurementId: 'G-YLGR540X04',
  deleteAuthKey: 'mvx%uh&148v8n4PMqbkvjl1N9BqVDgFrxd'
};
